import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { Upload as UploadIcon } from '@mui/icons-material'
import axios from 'src/utilities/http-client'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { useState } from 'react'
import { UserCapAlert } from 'src/v3/components/user-cap-alert'
import { isNil } from 'src/utilities/is-nil'
import {
  selectSelectedLinkedService,
  errorMessageChanged,
  selectLinkedServiceById,
  successMessageChanged,
  selectLinkedServiceRosterByID,
} from '../admin.slice'

export default () => {
  let dispatch = useAppDispatch()
  let selectedLinkedService = useAppSelector(selectSelectedLinkedService)
  let linkedService = useAppSelector(
    selectLinkedServiceById(selectedLinkedService),
  )
  let roster = useAppSelector(
    selectLinkedServiceRosterByID(selectedLinkedService),
  )
  let [uploading, setUploading] = useState<boolean>(false)

  let userCount = roster ? Object.keys(roster).length : 0
  let userCap = linkedService?.userCap
  // Non-null when the user cap has been reached, carrying the cap value for display
  let reachedCap = !isNil(userCap) && userCount >= userCap ? userCap : null

  let inviteUsers = (csvFile: FormData, linkedServiceID: string) =>
    axios.post<unknown>(
      `/api/admin/linked-service-user/bulk?linkedServiceID=${linkedServiceID}`,
      csvFile,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    )

  let handleBulkUpload = (event: any) => {
    let input = event.target.files[0]
    let csvData = new FormData()
    csvData.append('csvFile', input)
    setUploading(true)

    inviteUsers(csvData, linkedService?.id || '')
      .then(() => setUploading(false))
      .then(() => dispatch(successMessageChanged('CSV uploaded successfully!')))
      .catch((err) => {
        setUploading(false)
        dispatch(
          errorMessageChanged(err?.response?.data || err?.response?.status),
        )
      })
  }

  return (
    <Box className="w-full">
      <Box className="flex items-center gap-6">
        <Typography
          variant="subtitle2"
          color="textSecondary"
          sx={{ fontWeight: 600 }}
        >
          Bulk Upload Users
        </Typography>
        <Box>
          {uploading ? (
            <CircularProgress size={30} />
          ) : (
            <label
              className={
                !isNil(reachedCap) ? 'cursor-not-allowed' : 'cursor-pointer'
              }
            >
              <Button
                startIcon={<UploadIcon />}
                color="primary"
                variant="contained"
                component="span"
                disabled={!isNil(reachedCap)}
                sx={{ minHeight: '40px' }}
              >
                <input
                  accept=".csv"
                  className="hidden"
                  type="file"
                  onChange={handleBulkUpload}
                  disabled={!isNil(reachedCap)}
                />
                Upload CSV
              </Button>
            </label>
          )}
        </Box>
      </Box>
      {!isNil(reachedCap) && (
        <Box className="mt-4">
          <UserCapAlert userCap={reachedCap} />
        </Box>
      )}
      <Box className="mt-1">
        <Typography variant="body2" color="textSecondary">
          *The CSV should contain the columns: Email
        </Typography>
      </Box>
    </Box>
  )
}
